// What the week menu's Print prints (see PrintPortal): the week's meals by
// day, then the snack, preserves and medicinal lists, black on white.
import { useMealPlanner } from "../../hooks/MealPlannerContext";
import { PrintPortal } from "../PrintPortal";
import { COLORS, DINING_OUT, FONT_SIZE, MEAL_SLOTS, MISSING_RECIPE_LABEL, RECIPE_TYPE_LABELS, SPACE } from "../../lib/constants";
import { formatMinutes, formatWeekRange, orderedDays } from "../../lib/utils";
import { normalizeDishes } from "../../lib/planUtils";
import { mealKey } from "../../lib/planScaling";
import type { Day, DishType } from "../../lib/types";

const heading = { fontSize: FONT_SIZE.lg, fontWeight: 700, borderBottom: `1px solid ${COLORS.printRule}`, marginBottom: SPACE.sm, paddingBottom: SPACE.hair };

export function PlanPrint() {
  const mp = useMealPlanner();
  const wd = mp.weekData;
  const title = (id: string) => mp.recipeById(id)?.title ?? MISSING_RECIPE_LABEL;
  const lists = [
    ["Snacks and treats", wd.snacks],
    ["Preserves", wd.preserves],
    ["Medicinal", wd.medicinal],
  ] as const;
  return (
    <PrintPortal>
      <div className="mp-sans">
        <div style={{ fontSize: FONT_SIZE.h3, fontWeight: 700, marginBottom: SPACE.xs }}>{wd.title || `Week of ${formatWeekRange(mp.weekStart)}`}</div>
        {wd.title && <div style={{ fontSize: FONT_SIZE.base, marginBottom: SPACE.xl }}>Week of {formatWeekRange(mp.weekStart)}</div>}
        <div style={{ display: "flex", gap: SPACE.x4, fontSize: FONT_SIZE.base, marginBottom: SPACE.x3 }}>
          <span>People served: {wd.servings || 4}</span>
          <span>Total time: {formatMinutes(mp.weeklyTotalTime)}</span>
        </div>
        {(orderedDays(mp.planDefaults.weekStartDay) as Day[]).map((day) => {
          const rows = MEAL_SLOTS.map((slot) => {
            const entries = (Object.entries(normalizeDishes(wd.days[day]?.[slot])) as [DishType, string][]).filter(([, id]) => id);
            return { slot, entries };
          }).filter((r) => r.entries.length > 0);
          if (rows.length === 0) return null;
          return (
            <div key={day} style={{ marginBottom: SPACE.xxl }}>
              <div style={heading}>{day}</div>
              {rows.map(({ slot, entries }) => (
                <div key={slot} style={{ fontSize: FONT_SIZE.base, marginBottom: SPACE.xs }}>
                  <span style={{ fontWeight: 700, textTransform: "capitalize" }}>{slot}:</span>{" "}
                  {entries
                    .map(([dt, id]) => `${RECIPE_TYPE_LABELS[dt]}: ${id === DINING_OUT ? "Dining out" : `${wd.leftovers?.[mealKey(day, slot, dt)] ? "Leftovers, " : ""}${title(id)}`}`)
                    .join("; ")}
                </div>
              ))}
            </div>
          );
        })}
        {lists.map(([label, list]) =>
          (list || []).length === 0 ? null : (
            <div key={label} style={{ marginBottom: SPACE.xxl }}>
              <div style={heading}>{label}</div>
              {list.map((e, i) => (
                <div key={i} style={{ fontSize: FONT_SIZE.base, marginBottom: SPACE.xs }}>
                  {title(e.recipeId)}
                </div>
              ))}
            </div>
          )
        )}
      </div>
    </PrintPortal>
  );
}
